<template>
  <div>
      <ga-view-details></ga-view-details>
      <ga-view-monitoring></ga-view-monitoring>
      <ga-view-goals></ga-view-goals>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import GaViewGoals from './GaViewGoals.vue';
import GaViewDetails from './GaViewDetails.vue';
import GaViewMonitoring from './GaViewMonitoring.vue';

export default {
    components: {
        GaViewGoals,
        GaViewDetails,
        GaViewMonitoring,
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/GaViewDetailsView.vue